const animationClass = 'button__refresh--load'

const Reorder = {
  init(target) {
    if (target) {
      target.addEventListener('click', this.onClick)
    }
  },
  onClick(e) {
    e.currentTarget.classList.add(animationClass)
    e.currentTarget.innerHTML = `<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>`
  },
}

export default Reorder
